/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import NProgress from 'nprogress';
import Backbone from 'backbone';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { getUserDetails, isAuthorized } from '@/util/RoleUtils';
import ErrorView from '@/views/ErrorView';
import GetAllOrderFormTypes from '@/services/GetAllOrderFormTypes';

import CreateOrderPage from '../pages/CreateOrderPage';

export default async function ShowCreateOrderPage() {
  NProgress.start();

  try {
    NavUtils.navigate('ext/order/create');

    if (EXTERNAL && !isAuthorized()) {
      showAuthError();
      return;
    } else if (!EXTERNAL) {
      showErrorView();
    }

    const userDetails = getUserDetails();
    const commandId = userDetails?.actingAsCommandId;
    const commandName = userDetails?.commandName;

    if (!commandId) {
      showCommandError();
      return;
    }
 

    let orderFormTypes = await GetAllOrderFormTypes();
    orderFormTypes = _.filter(orderFormTypes, (type) => {
      //remove original PRTNR form from order types
      return type.id !== '2';
    });
    _.each(orderFormTypes, (x) => {
      x.name = x.descriptiveFormName;
    });

    Scaffold.getRegion('content').show(
      new CreateOrderPage({
        model: new Backbone.Model({
          returnLabel: 'Return to Dashboard',
          returnLink: '#ext/dashboard',
          commandId,
          commandName,
          orderFormTypes
        })
      })
    );
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Create Order page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showCommandError(){
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Not Authorized',
        errorDetails: "Have you recently been granted command access? Please logout, clear cookies, and try again. If issues persist, please contact an administrator."
      })
    })
  );
  NProgress.done();
}

function showAuthError() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Not Authorized',
        errorDetails: 'You are not yet an authorized user. Please contact an administrator.'
      })
    })
  );
  NProgress.done();
}

function showErrorView() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the External Create Order page.'
      })
    })
  );
  NProgress.done();
}